module.exports = __webpack_public_path__ + "static/media/27336974_1966554510274978_6993237461120942250_n1.c2a02ad7.jpg";